
import React, { useState } from "react";
import { Dropdown, Offcanvas } from "react-bootstrap";
import NotificationIcon from "../assets/png/NotificationIcon.svg";
import MailIcon from "../assets/png/MaiIcon.svg";
import ProfileIcon from "../assets/png/profileIcon.svg";
import logo from "../assets/svg/logo.svg";
import { FaBars, FaTimes } from "react-icons/fa"; // Add FaTimes
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Cookies from "js-cookie";
const Header = () => {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);

  const handleLogout = () => {
    // localStorage.removeItem("token");
    navigate("/login");
  };

  const handleToggleSidebar = () => setShowSidebar(!showSidebar);
  const handleCloseSidebar = () => setShowSidebar(false);

  return (
    <>
      <div className="header d-flex align-items-center justify-content-between px-4 py-3 shadow-sm bg-white">
        <div className="text-center">
          <img src={logo} height={35} alt="logo" className="logo" />
        </div>

        <div className="d-flex align-items-center gap-md-4 gap-2">
          {/* <img
            className="mt-3"
            width={30}
            height={24}
            src={MailIcon}
            alt="MailIcon"
          />
          <img
            width={30}
            height={37}
            src={NotificationIcon}
            alt="NotificationIcon"
            className="logo"
          /> */}

          {/* Profile Dropdown */}
          <Dropdown align="end">
            <Dropdown.Toggle
              as="div"
              id="dropdown-user"
              className="d-flex align-items-center text-decoration-none p-0 border-0 bg-transparent"
              style={{ cursor: "pointer" }}
            >
              <img
                width={41}
                height={41}
                src={ProfileIcon}
                alt="Profile"
                className="rounded-circle me-5"
              />
              {/* <span className="ms-2 d-none d-lg-block text-black">User</span> */}
            </Dropdown.Toggle>

            <Dropdown.Menu className="mt-1 py-0">
              <Dropdown.Item className="py-2" href="#">
                Profile
              </Dropdown.Item>
              <Dropdown.Divider className="my-0 py-0" />
              <Dropdown.Item onClick={()=>{
                Cookies.remove("token")
                window.location.reload()
              }} className="py-2">
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* Toggle Icon (FaBars or FaTimes based on state) */}
          {showSidebar ? (
            <FaTimes
              className="d-md-none cursor-pointer"
              size={22}
              onClick={handleCloseSidebar}
            />
          ) : (
            <FaBars
              className="d-md-none cursor-pointer"
              size={22}
              onClick={handleToggleSidebar}
            />
          )}
        </div>
      </div>

      {/* Offcanvas Sidebar */}
      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} placement="end">
        <Offcanvas.Body>
          <Sidebar />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Header;
